// node modules
import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
// modules
import { useStore } from 'modules/Stores';

type Props = {
  children: JSX.Element;
  live?: boolean;
  portfolioV2?: boolean;
};

const WsProvider: React.FC<Props> = (props) => {
  const { children, portfolioV2, live } = props;
  const { sendTechIssueNotification } = useStore('NotificationStore');

  const {
    connected: portfolioV2Connected,
    failed: portfolioV2Failed,
    connect: portfolioV2Connect,
  } = useStore('WsPortfolioV2Feeder');

  const {
    connected: liveConnected,
    failed: liveFailed,
    connect: liveConnect,
  } = useStore('WsLiveV2Feeder');

  const { loadings: { APP_INIT } } = useStore('LoadingStore');

  useEffect(() => {
    if (portfolioV2Failed && liveFailed) {
      sendTechIssueNotification('BOTH');
    } else if (liveFailed) {
      sendTechIssueNotification('LIVE');
    } else if (portfolioV2Failed) {
      sendTechIssueNotification('MARKET');
    }
  }, [portfolioV2Failed, liveFailed, sendTechIssueNotification]);

  useEffect(() => {
    if (!APP_INIT && live && !liveConnected && !liveFailed) {
      liveConnect();
    }
  }, [live, liveConnect, liveConnected, liveFailed, APP_INIT]);

  useEffect(() => {
    if (portfolioV2 && !portfolioV2Connected && !portfolioV2Failed) {
      portfolioV2Connect();
    }
  }, [
    portfolioV2,
    portfolioV2Connected,
    portfolioV2Failed,
    portfolioV2Connect,
  ]);

  return children;
};

export default observer(WsProvider);
